import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-solid-svg-icons'
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export default function HotelCard({hotel}) {
  return (
    <Card sx={{ maxWidth: 345, m: 2 }}>
      <CardMedia
        component="img"
        height="140"
        image={hotel.image_url}
        alt="green iguana"
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {hotel.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Rating: {hotel.rating} <FontAwesomeIcon icon={faStar}/>
          <br/>
          Price: {hotel.price}/day
        </Typography>
      </CardContent>
      <CardActions>
        <Button size="small" onClick={() => window.open(hotel.booking_url)}>Learn More</Button>
      </CardActions>
    </Card>
  );
}
